import React                                                        from 'react';
import { withStyles }                                               from '@material-ui/core/styles';
import {colores, globales,funciones}                                from '../../global';
import BarraBotones                                                 from '../../components/Barra_menu';
import AuthService                                                  from '../../AuthService';
import Request                                                      from 'superagent';
import CustomTable                                                  from '../../components/CustomTable';
import {Table}                                                      from '@devexpress/dx-react-grid-material-ui';
import TableRowsIndexer                                             from '../../components/tableRowsIndexer'
import Select                                                       from '../../components/Select';
import MenuItem                                                     from '@material-ui/core/MenuItem';
import { Typography }                                               from '@material-ui/core';
import Reporte                                                      from '../../components/Modalreporte';

let Auth = new AuthService();
var ip=globales.ip
var border_dialog=globales.border_dialog
//var movil=/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
var movil_pequeño=/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

let isVisibleRowSelected = false;
//const colorRowSelected =  'rgb('+ colores.tabla.selection +')';
//let alternateColorRow1 =  colores.tabla.alternateColorRow1; 
//let alternateColorRow2 =  colores.tabla.alternateColorRow2;

//const ListboxComponent = virtual.ListboxComponent;


const getRowId = row => row.ID_SECCION;



/*                           CLASES DE ESTILO                       */

var styles = theme =>({
    Dialog:{
        borderRadius: border_dialog,
        margin:0,
        padding:0
    },
    backdrop: {
      zIndex: 500000,
      color: '#fff', 
      flexDirection: 'column'
    },
    select: { //CONFIGURA EL SELECT 
        margin: theme.spacing(movil_pequeño?2:1, 1,0,0),
        padding: 0,
        minWidth: movil_pequeño?'100%':'20%',
      },
      textField: {
        margin: theme.spacing(movil_pequeño?2:1, 1,0,0),
        padding: 0,
        minWidth: movil_pequeño?'100%':'20%',
        width: '20%'      
      },
    })

    const columns= [
      {name:'ID_SECCION',title: 'ID_SECCION'}
      ,{name:'CODIGO_CURSO',title: 'Código'}
      ,{name:'DESCRIPCION_CURSO',title: 'Descripción'}
      ,{name:'INICIO',title: 'Inicio'}
      ,{name:'FIN',title: 'Fin'}
      ,{name:'SECCION',title: 'Sección'}
      ,{name:'CODIGO',title: 'Aula'}
      ,{name:'ANIO',title: 'ANIO'}
      ,{name:'PERIODO',title: 'PERIODO'}
    ];

    const defaultHiddenColumnNames= ['ANIO','PERIODO','ID_SECCION'];

    const tableColumnExtensions= [
        { columnName: 'CODIGO_CURSO', wordWrapEnabled: false, align: 'center',width: 150},
        { columnName: 'DESCRIPCION_CURSO', wordWrapEnabled: false, align: 'center'},
        { columnName: 'INICIO', wordWrapEnabled: false, align: 'center',width: 150},
        { columnName: 'FIN', wordWrapEnabled: false, align: 'center',width: 150},
        { columnName: 'SECCION', wordWrapEnabled: false, align: 'center',width: 150},
        { columnName: 'CODIGO', wordWrapEnabled: false, align: 'center',width: 150},
    ];

/*                                        EXPORT                                      */
export default withStyles(styles)(
    class Discusion_Catedratico extends React.Component {
      tablaRef = React.createRef();

      constructor(props) {
        super(props);
        this.l= props.l
        this.e= props.e
        this.i= props.i
        this.isVisibleRowSelected=isVisibleRowSelected
        this.actualizarbarra=props.actualizarbarra
        this.actualizarcircular=props.actualizarcircular

        this.state = {
            openBackDrop:      false, 
            isLoggin:          undefined,
            heightTableMain:    0,
            rows: [],
            selection: [],
            selection_ponderacion: '',
            datos_ponderaciones: [],
            grouping: [],
            expandedGroups: [],
            filteringColumnExtensions: [],
            filters: [],
            expandedRowIds: [],
            enabledFilterRows: false,
            selection_row:  []
        }

        const VirtualTable_cellComponent = (getTime) => (props) => {
          const { column }    = props;
          const {row}         = props;
      
          if (column.name === 'INICIO')
        {
          return ( <Table.Cell {...props} style={{padding: 0, height:'8px',}}>
                    { row.INICIO !== null ? getTime(row.INICIO, 1) : row.INICIO }
                  </Table.Cell>);
        }
      
        if (column.name === 'FIN')
        {
          return ( <Table.Cell {...props} style={{padding: 0, height:'8px',}}>
                    { row.FIN !== null ? getTime(row.FIN, 1) : row.FIN }
                  </Table.Cell>);
        }
          
        return(
          <Table.Cell {...props}/>
        );
      }

        this.VirtualTable_cellComponent = VirtualTable_cellComponent;
        
    }; //FIN CONSTRUCTORS


componentDidMount()
{
        let _this = this;
        _this.actualizarbarra(false)

        //Auth.loggedIn().then( function(b){ Auth.getProfile()
        //    _this.setState({ isLoggin: b})
        //    if(b)
         //   {
        this.setState({ isLoggin: Auth.getProfile().plataforma !== undefined ? true : false }, ()=>{
            Request.get(`${ip}/discusionCatedratico/obtener_cursos_catedratico/${Auth.getProfile().user}`)
            .set({'authorization': 'Bearer ' + Auth.getToken() })
            .retry(1)
            .timeout({ response: 20000, deadline: 50000, }) 
            .end((err, res)=> {
             if (err) { 
                    if (err.toString().substr(0,16) === 'Error: Forbidden')
                    {
                      window.location.reload();
                      return;  
                    }
                    (async function() {
                        funciones.showToast('e','Error de conexión')
                    })();//FIN FUNCION ASYNC
                    return;
            }
            const tmp = JSON.parse(res.text);
            if(tmp.length>0){
                _this.setState({ rows: tmp, heightTableMain: funciones.getHeightTableMain(movil_pequeño,_this).heightTable})
            }
            else
            {
                _this.setState({rows: [], heightTableMain: funciones.getHeightTableMain(movil_pequeño,_this).heightTable })
            }
            _this.actualizarbarra(true)
            })

            Request.get(`${ip}/discusionCatedratico/obtener_ponderaciones/${Auth.getProfile().user}`)
            .set({'authorization': 'Bearer ' + Auth.getToken() })
            .retry(1)
            .timeout({ response: 20000, deadline: 50000, }) 
            .end((err, res)=> {
             if (err) { 
                    if (err.toString().substr(0,16) === 'Error: Forbidden')
                    {
                      window.location.reload();
                      return;  
                    }
                    (async function() {
                        funciones.showToast('e','Error de conexión')
                    })();//FIN FUNCION ASYNC
                    return;
            }
            const tmp = JSON.parse(res.text);
            if(tmp.length>0){
              const Datos = tmp.map((datos, i) =>
              <MenuItem dense  value={datos.ID_PONDERACION} key={datos.DESCRIPCION_PONDERACION} name={datos.DESCRIPCION_PONDERACION}  >
               {datos.DESCRIPCION_PONDERACION}
              </MenuItem>
              );
              _this.setState({ datos_ponderaciones: Datos})
            }
           
            _this.actualizarbarra(true)
            })

          //}/// fin if(b)
        })
}

changeSelection = (selection) =>{
  if(selection[selection.length-1]===undefined)
  {
      this.setState({ selection: this.state.selection});
  }
  else{
      this.state.rows.forEach(element => {
        if(element.ID_SECCION===funciones.getIdRowChecking(selection,this.state.selection))
        {
          this.setState({selection: [selection[selection.length-1]],selection_row:[{ANIO:element.ANIO,PERIODO: element.PERIODO
            ,CODIGO_CURSO: element.CODIGO_CURSO,ID_SECCION: element.ID_SECCION}]})
          return;
        }
      });
     
  }
}

ChangeSelect_ponderacion = event => {
  this.setState({ selection_ponderacion: event.target.value });
}

generarreporte=event=>{
  if(this.state.selection.length!==0 && this.state.selection_ponderacion!=='')
  document.getElementById("BT-discusion").click();
}

/*                                          RENDER                          */
render() {
    const { classes } = this.props;

    const botones = [
        {icono: 'Add', toolt: 'Generar Reporte',    nombre: 'Generar'   ,escritura:true, disabled: this.state.selection.length===0 || this.state.selection_ponderacion==='' , onclick: this.generarreporte
        ,  display: 'auto'},
      ]

    if (this.state.isLoggin === true )
    {
    return (    
    <React.Fragment>
      <Reporte id="BT-discusion" parametros={this.state.selection_row[0]!==undefined?this.state.selection_row[0].ANIO.toString()+','+this.state.selection_row[0].PERIODO.toString()+','+Auth.getProfile().user+','+this.state.selection_row[0].CODIGO_CURSO+','+this.state.selection_ponderacion.toString()+','+this.state.selection_row[0].ID_SECCION.toString():''} 
      nom_boton="Generar" nom_bar="Discusión de Evaluación" 
        label_reporte={'DiscusionCatedratico'}
        backcolor={colores.azul} fill={'white'} fullScreen={true} boton={false}  color="primary" color_bar='primary'
        opciones={false}
      />
      <div align="left" style={{marginLeft:movil_pequeño?0:20,marginBottom: 20,marginTop: 20}}>
      <Typography align='left'>
        Descripción columna en reporte:
      </Typography>
      <Select Label="Ponderación"
          Datos = {this.state.datos_ponderaciones}
          Selected={this.state.selection_ponderacion}
          onChange={this.ChangeSelect_ponderacion}
          Multiple = {false}
          SelectClass={{height: movil_pequeño?'auto':36}}
          Style = {classes.select}
          ShowItemNone = {true}
          LabelItemNone = '' ValueItemNone = ''
          AutoFocus = {false}  Outlined = {true}
      />
      </div>
      <div ref={this.tablaRef} style={{background:'white',marginLeft:movil_pequeño?globales.tabla.marginleft_movil:globales.tabla.marginleft,marginRight:movil_pequeño?globales.tabla.marginright_movil:globales.tabla.marginright}}>
        <CustomTable
            Columns={columns}                                    
            Rows={this.state.rows}                                          
            TableColumnExtensions={tableColumnExtensions}
            DefaultHiddenColumnNames={defaultHiddenColumnNames}
            getRowId = {getRowId}
            Selection={this.state.selection}
            ChangeSelection = {this.changeSelection}
            height={this.state.heightTableMain-80}
            //Filters = {this.state.filters}
            //onFiltersChange = {this.changeFilters}
            //ExpandedGroups = {this.state.expandedGroups}
            //ExpandedRowIds = {this.state.expandedRowIds}
            enabledFilterRows= {this.state.enabledFilterRows}
            standarPlugin = { <TableRowsIndexer/> }
            VirtualTable_cellComponent={this.VirtualTable_cellComponent(funciones.getTime)}
            //rowHeaderCellComponent={TableTreeColumnHeader_cellComponent}
            showSelectionColumn={true}
        />
      </div>
      <BarraBotones align='center' botones={botones} l={this.l} e={this.e} i={this.i}/>
    </React.Fragment>
    ); /// finaliza return
    }
    else if (this.state.isLoggin === false)
    {
        Auth.logout()
        window.location.reload();
        return; 
    }


    return null;
} /// finaliza render
} /// finaliza class
)/// finaliza withStyles

    

    